<template>
  <div class="overall-bg p-0 position-relative">
    <div class="tabviewtable">
      <!-- {{ barcodeValues }}ll -->
      <!-- {{ ParamValues.DocNo }} -->
      <TabView class="tabview-custom" ref="tabview4" :scrollable="true">
        <TabPanel>
          <template #header>
            <span style="padding: 0px 7px">{{ $t("grn.grn") }}
              <Badge :value="ObjVal5.arraylenght" severity="warning" v-if="QueryStringValue4.StroeId"></Badge>
            </span>
          </template>
          <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
            <div class="">
              <div class="filter_chip" v-if="filterItemsArray[0]['Date'] != ''">
                <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
                <span @click="removeChip('Date')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['Code'] != ''">
                <span>PO code: {{ filterItemsArray[0]["Code"] }}</span>
                <span @click="removeChip('Code')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['SupplierName'] != ''">
                <span>Supplier Name:
                  {{ filterItemsArray[0]["SupplierName"] }}</span>
                <span @click="removeChip('SupplierName')"><i class="pi pi-times"></i>
                </span>
              </div>
            </div>
            <div class="">
              <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                Clear all
              </button>
            </div>
          </div>
          <div class="form-white-bg" v-if="windowWidth > 545">
            <b-row>
              <b-col :lg="togglevisible ? '3' : '0'" v-if="items.length !== 0">
                <b-collapse id="collapse-1" class="mt-2" v-model="togglevisible">
                  <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                    :ClearDateFilter="SearchValue" v-if="FilterLoading">
                    <template v-slot:filterslot>
                      <poGrnFilters @suppliersename="EmitSupplierName" @supplierseid="EmitSupplierId"
                        @updatedcode="Emitcode" :removechiptype="removechipvalue" :showFields="false" />
                    </template>
                  </FilterForm>
                </b-collapse>
              </b-col>
              <b-col :lg="items.length !== 0 && togglevisible ? '9' : '12'">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty :createline="QueryStringValue4.StroeId || IsAddButton" v-if="
                    items.length == 0 &&
                    !SearchValue.inputValue &&
                    !SearchValue.fromDate &&
                    !SearchValue.toDate &&
                    !DetailsId.PIId &&
                    !DetailsId.PRId
                  " eheader="GRN" econtent="GRN" eimg="../../../../../../assets/Img/icons/itemmaster.svg"
                    @createNew="IsCreatePopup()" />
                  <!-- {{ items }} -->

                  <Tableview v-if="
                    items.length !== 0 ||
                    SearchValue.inputValue ||
                    SearchValue.fromDate ||
                    SearchValue.toDate
                  " :value="items" :paginator="false" class="p-datatable-gridlines" :rows="state.pageSize" dataKey="Id"
                    :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                    :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" @row-click="RowClick"
                    :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :exceldownload="true"
                    :filterbtn="true" :searchbox="false" :searchbox1="true" @search="SearchBox"
                    :showColumnFilters="false">
                    <template v-slot:exceldownload>
                      <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                        :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                    </template>
                    <template v-slot:ApprovalStatus="{ data }">
                      <div v-if="data.IsDraft == '1'">
                        <span>-</span>
                      </div>
                      <div v-else>
                        <OrangeStatus name="Pending" v-if="data.IsApproved == '0'" />
                        <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
                        <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
                      </div>
                    </template>
                    <template v-slot:PaymentStatus="{ data }">
                      <div v-if="data.DocType == 19">-</div>
                      <template v-else>
                        <OrangeStatus name="Pending" v-if="data.IsDraft != 1 && data.PaymentFlag == '2'" />
                        <BlueStatus name="Partially Paid" v-if="data.IsDraft != 1 && data.PaymentFlag == '3'" />
                        <GreenStatus name="Paid" v-if="data.IsDraft != 1 && data.PaymentFlag == '1'" />
                        <RedStatus name="OverDue" v-if="data.IsDraft != 1 && data.PaymentFlag == '4'" />
                        <div v-if="
                          data.IsDraft != 1 &&
                          (data.PaymentFlag == '2' || data.PaymentFlag == '4')
                        ">
                          <span>
                            Pending Since:{{
                              data.PendingDays == 0
                                ? "Today"
                                : data.PendingDays + " Days"
                            }}
                          </span>
                        </div>
                      </template>
                    </template>

                    <template v-slot:filter>
                      <i class="pi pi-filter tablefilter" :class="togglevisible ? null : 'collapsed'"
                        :aria-expanded="togglevisible ? 'true' : 'false'" aria-controls="collapse-4"
                        @click="togglevisible = !togglevisible"></i>
                    </template>
                    <template v-slot:Add
                      v-if="(!QueryStringValue4.StroeId && IsAddButton) && (DetailsId.PIId == 0 && DetailsId.PRId == 0)"
                      :searchbox="false" :searchbox1="true" @search="SearchBox">
                      <span class="add">
                        <AddButton @click="IsCreatePopup()" :btnname="$t('btn.plusaddnew')"></AddButton>
                      </span>
                    </template>
                    <template v-slot:action="{ data }">
                      <span>
                        <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                          @click="toggle($event, data)" />
                      </span>
                    </template>
                    <template v-slot:DocNo="{ data }">
                      <span>
                        <b>{{ data.DocNo }}</b>
                        <RedStatus name="Draft" v-if="data.IsDraft == '1'" />
                      </span>
                      <div>
                        {{
                          data.DocType == 7
                            ? "( GRN With PO )"
                            : data.DocType == 8
                              ? "( GRN Without PO )"
                              : data.DocType == 19 && data.DCType == 1
                                ? `( DC Consignee ) ${data.DCStatus == 0
                                  ? "GRN pending"
                                  : data.DCStatus == 1
                                    ? "GRN partial"
                                    : data.DCStatus == 2
                                      ? "GRN completed"
                                      : ""
                                }`
                                : data.DocType == 19 && data.DCType == 2
                                  ? "( DC Others )"
                                  : data.DocType == 19 && data.DCType == 3
                                    ? `( DC With PO ) ${data.DCStatus == 0
                                      ? "GRN pending"
                                      : data.DCStatus == 1
                                        ? "GRN partial"
                                        : data.DCStatus == 2
                                          ? "GRN completed"
                                          : ""
                                    }`
                                    : data.DocType == 19 && data.DCType == 4
                                      ? `( DC Without PO ) ${data.DCStatus == 0
                                        ? "GRN pending"
                                        : data.DCStatus == 1
                                          ? "GRN partial"
                                          : data.DCStatus == 2
                                            ? "GRN completed"
                                            : ""
                                      }`
                                      : ""
                        }}
                      </div>
                    </template>
                  </Tableview>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="
                items.length === 0 &&
                !SearchValue.inputValue &&
                !SearchValue.fromDate &&
                !SearchValue.toDate &&
                !DetailsId.PIId &&
                !DetailsId.PRId
              " eheader="GRN" econtent="GRN" eimg="../../../../../../assets/Img/icons/sub-tax.svg"
                @createNew="IsCreate" />
              <MobileViewCardHeader v-if="
                items.length !== 0 ||
                SearchValue.inputValue ||
                SearchValue.fromDate ||
                SearchValue.toDate
              " :totalRecords="rowsCount" :state="state" @IsAdd="IsCreate" @search="SearchBox">
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center gap-1">
                        <p class="light-name">{{ item["DocNo"] }}</p>
                        <p class="light-name1">/ {{ item["DocDate"] }}</p>
                      </div>
                      <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                    </div>
                    <p class="name">{{ item["SupplierName"] }}</p>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item count :</p>
                      <p class="small-name">{{ item["ItemCount"] }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item value :</p>
                      <p class="small-name">{{ item["Amount"] }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <template #header>
            <span style="padding: 0px 7px">{{ $t("grn.return") }}
              <Badge :value="ObjVal4.arraylenght" severity="warning" v-if="QueryStringValue4.StroeId"></Badge>
            </span>
          </template>
          <div>
            <GRNReturnTableView :propsParams="paramValues1" v-model="ObjVal4" :FunctionRights="functionrights"
              :IsAddButton="IsAddButton" :DetailsId="DetailsId" />
          </div>
        </TabPanel>
      </TabView>
    </div>
  </div>
  <div>
    <Dialog v-model:visible="visible" modal :header="$t('grnpopup.title')" :style="{ width: '70vw' }"
      :breakpoints="{ '960px': '75vw', '641px': '100vw' }">
      <b-row>
        <b-col sm="6" cols="12" lg="4">
          <div class="text-center grnpopup">
            <img class="grn-icon py-3" src="../../../../../../assets/Img/icons/with-po.svg" />
            <p class="common-heading1">{{ $t("grnpopup.withpo") }}</p>
            <p class="light-txt">
              {{ $t("grnpopup.withpocontent") }}
            </p>
            <Button @click="IsCreate('GRN With PO', 3031, 3031001)" class="my-3 grnbtn">{{ $t("grnpopup.choose")
            }}</Button>
          </div>
        </b-col>
        <b-col sm="6" cols="12" lg="4">
          <div class="text-center grnpopup">
            <img class="grn-icon py-3" src="../../../../../../assets/Img/icons/without-po.svg" />
            <p class="common-heading1">{{ $t("grnpopup.withoutpo") }}</p>
            <p class="light-txt">
              {{ $t("grnpopup.withoutpocontent") }}
            </p>
            <Button @click="IsCreate('GRN Without PO', 3032, 3032001)" class="my-3 grnbtn">{{ $t("grnpopup.choose")
            }}</Button>
          </div>
        </b-col>
        <b-col sm="6" cols="12" lg="4">
          <div class="text-center grnpopup">
            <img class="grn-icon py-3" src="../../../../../../assets/Img/icons/without-po.svg" />
            <p class="common-heading1">{{ $t("grnpopup.deliverychellon") }}</p>
            <p class="light-txt">
              {{ $t("grnpopup.deliverychelloncontent") }}
            </p>
            <Button @click="IsCreate('DC', 3073, 3073001)" class="my-3 grnbtn">{{
              $t("grnpopup.choose")
            }}</Button>
          </div>
        </b-col>
      </b-row>
    </Dialog>
  </div>
  <div>
    <div class="barcode-container d-none">
      <svg :id="'DocNo'"></svg>
    </div>
  </div>

  <Menu ref="menu" id="overlay_menu" :model="itemList" :popup="true" />
  <EditConfirmation :Editmodel="popup.Editmodel" @yes="IsEdit(dataEdit)" @no="popup.Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="popup.Deletemodel" @yes="IsDelete(dataEdit)" @no="popup.Deletemodel = false" />
  <DeletedSuccessfully :visible="popup.deletepop" @ok="closetrigger()" />
  <Toast />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  watch,
  reactive,
  computed,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import Table from "../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import GRNReturnTableView from "../../../../../../modules/Inventory/pages/Transaction/StockOut/grnreturn/GrnReturnTableview.vue";
import commonService from "../../../../Service/StockInService";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import poGrnFilters from "../../../../../../modules/Inventory/components/Filters/poGrnFilters.vue";
import moment from "moment";
import FilterForm from "../../../../../../components/FormComponents/FilterForm.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import JsBarcode from "jsbarcode";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,

    Table,
    Tableview,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    Loader,
    MasterEmpty,
    GRNReturnTableView,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    CrystalReportPrintPopUp,
    poGrnFilters,
    FilterForm,
    ExportOption,
  },
  props: {
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
    IsAddButton: {
      type: Boolean,
      default: true,
    },
    QueryValue: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });
    const { t } = useI18n();
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    let togglevisible = ref(false);

    const rowsCount = ref(0);
    const visible = ref(false);
    const router = useRouter();
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    let functionrights: any = ref("");
    let objectdata = ref({});
    let Grnvisible = ref();

    const routes = useRoute();
    let StoreId = routes.query.Id ?? 0;
    let status = routes.query.status ?? 0;
    let Type = routes.query.Type;
    let StoreBrMapId = routes.query.storebranchmapid ?? 0;
    let BranchId = Number(routes.query.BranchId ?? 0);
    const ColumnVisible = ref(true);


    const toast = useToast();

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let QueryStringValue: any = routes.query;

    let DetailsId = ref({
      PIId: QueryStringValue["PIId"] ?? 0,
      PRId: QueryStringValue["PRId"] ?? 0,
    });

    if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
      ColumnVisible.value = true;
    } else {
      ColumnVisible.value = false;
    }

    watch(
      () => [props.QueryValue],
      ([newQueryValue]) => {
        debugger;
        if (newQueryValue.PIId) {
          DetailsId.value.PIId = newQueryValue.PIId;
        } else if (newQueryValue.PRId) {
          DetailsId.value.PRId = newQueryValue.PRId;
        }
      },
      { immediate: true }
    );

    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 2,
      HeaderTitle: "GRN",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("GRN");
    let ExportOption = ref("");

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });
    const ParamValues = ref({
      requestId: "",
      Id: 0,
      Type: 0,
      DocNo: 0,
      StockTransId: 0,
      type: 1,
      SupplierId: 0,
      StoreId: 0,
      status: "",
      BranchId: 0,
      GrnpoNumber: 0,
      GrnpoId: 0,
      DocType: 0,
    });

    ParamValues.value.Id = Number(StoreId);
    ParamValues.value.StoreId = Number(StoreId);

    ParamValues.value.Type = Number(status);
    ParamValues.value.status = String(Type);
    ParamValues.value.BranchId = Number(BranchId);

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    watch(
      props,
      (newValue: any) => {
        debugger;
        functionrights.value = props.FunctionRights;
        console.log("props Changed", newValue.FunctionRights);
        Rights.value.Create = newValue.FunctionRights.Create;
        Rights.value.Update = newValue.FunctionRights.Update;
        Rights.value.Read = newValue.FunctionRights.Read;
        Rights.value.Delete = newValue.FunctionRights.Delete;
        Object.keys(ObjOperationId.value).forEach((key) => {
          if (newValue.FunctionRights[key])
            ObjOperationId.value[key] = newValue.FunctionRights[key];
        });
      },
      { deep: true }
    );

    const paramValues1 = ref({
      Id: "",
      Type: "",
      status: 0,
    });

    let dataValue = {
      Id: "",
      status: "",
      Type: "",
    };

    let ObjVal4 = ref({
      arraylenght: 0,
    });

    const loading = ref(false);

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        ParamValues.value.Id = Number(dataValue.Id);
        ParamValues.value.status = dataValue.Type;
        ParamValues.value.Type = Number(dataValue.status);
        IsShow();

        paramValues1.value.Id = dataValue.Id;
        paramValues1.value.Type = String(dataValue.Type);
        paramValues1.value.status = Number(dataValue.status);
      }
    });

    let btnEditHide = ref(true);
    let btnDeleteHide = ref(false);

    let QueryStringValue4: any = routes.query;
    // if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
    //   btnEditHide.value = true;
    //   btnDeleteHide.value = true;
    // } else {
    //   btnEditHide.value = false;
    //   btnDeleteHide.value = false;
    // }
    let IsZeroBill = routes.query.IsZeroBill ?? "false";

    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        GRNDetails();
      } else {
        IsShow();
      }
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    const totalPages = computed(() => {
      return Math.ceil(rowsCount.value / state.pageSize);
    });

    const pageSizes = computed(() => {
      const pageSizeOptions: { value: number; text: string }[] = []; // Add type annotation here
      let startSize = 10;
      let rowsLeft = rowsCount.value;

      while (rowsLeft > 0) {
        const pageSizeOption = { value: startSize, text: `${startSize}` };
        pageSizeOptions.push(pageSizeOption);

        startSize *= 2;
        rowsLeft -= startSize / 2;
      }

      return pageSizeOptions;
    });

    const menu = ref();
    const popup = ref({
      Deletemodel: false,
      deletepop: false,
      Editmodel: false,
    });

    const dataEdit = ref();

    function datapass(data) {
      debugger;
      console.log(data["DocNo"]);
      ParamValues.value.requestId = data["DocNo"];
      router.push({
        path: "/Issue",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "IndirectIssue",
        },
      });
    }

    const toggle = (event, data) => {
      // debugger;
      barcodeValues.value = data;
      generateBarcodes();
      console.log(data);
      ParamValues.value.DocNo = data.DocNo;
      ParamValues.value.DocType = data.DocType;

      ParamValues.value.StockTransId = data.StockTransId;
      (ParamValues.value.GrnpoNumber = data.DocNo),
        (ParamValues.value.GrnpoId = data.RefId),
        console.log(ParamValues.value.DocNo);
      ParamValues.value.SupplierId = data.SupplierId;
      objectdata = data;
      if (data.ReturnStatus == 0 && data.DocType != 19 && data.IsDraft == 0) {
        Grnvisible.value = true;
      } else {
        Grnvisible.value = false;
      }
      menu.value.toggle(event);
    };

    const itemList = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: btnEditHide,
            command: async () => {
              IsConfirmEdit(objectdata);
            },
          },
          {
            label: "Convert to Asset",
            icon: "pi pi-sync",
            visible: true, // Hidden by Antony for Aravind Eye Care. Kindly make it visible again without any hesitation.
            command: async () => {
              router.push({
                name: "GrnItemTableview",
                path: "/GrnItemTableview",
                query: {
                  data: JSON.stringify(ParamValues.value),
                  param: "GrnAssetItemTableview",
                },
              });
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: btnDeleteHide,
            command: async () => {
              IsConfirmDel(objectdata);
            },
          },
          {
            label: "GRN Return",
            icon: "pi pi-directions",
            visible: Grnvisible,
            command: async () => {
              grnrRoute(objectdata);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(objectdata);
            },
          },
          {
            label: "BarCodePrint",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              BarcodePrint(objectdata);
            },
          },
        ],
      },
    ]);
    //let barcodeValues: any = ref(ParamValues.value.DocNo)
    interface Barcode {
      BarCode: string;
    }
    const barcodeValues: any = ref<Barcode>();
    const generateBarcodes = () => {
      setTimeout(() => {
        JsBarcode("#DocNo", barcodeValues.value.DocNo, {
          format: "CODE128",
          displayValue: true,
        });
      }, 600);
    };
    // const printBarcodes = (barcodeValues) => {
    //   debugger
    //   if (barcodeValues) {
    //     const printWindow = window.open('', 'PRINT', 'height=400,width=600');
    //     if (printWindow) {
    //       printWindow.document.write('<html><head><title>Print Barcodes</title></head><body>');
    //       const barcodeElement = document.getElementById('DocNo');
    //       if (barcodeElement) {
    //         const svgData = new XMLSerializer().serializeToString(barcodeElement);
    //         printWindow.document.write(`<div>${svgData}</div>`);
    //       }
    //       printWindow.document.write('</body></html>');
    //       printWindow.document.close();
    //       printWindow.focus();
    //       // setTimeout(() => {
    //       //   printWindow.print();
    //       //   printWindow.close();
    //       // }, 1000);
    //     }
    //   };
    // }
    const grnrRoute = (data) => {
      debugger;
      router.push({
        name: "GRNReturn",
        query: {
          param: "GRNReturn",
          StoreId: ParamValues.value.Id,
          status: ParamValues.value.Type,
          Type: ParamValues.value.status,
          refNo: ParamValues.value.DocNo,
          RefId: ParamValues.value.StockTransId,
          SupplierId: ParamValues.value.SupplierId,
          OperationId: 3026001,
          EntityId: 3026,
          Id: 0,
          storebranchmapid: StoreBrMapId,
          BranchId: ParamValues.value.BranchId,
          IsGRNDetails: 0,
        },
      });
    };

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DocDate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      SupplierName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t("storetabdetails.grn.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.grn.BranchName"),
        field: "BranchName",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.grn.Code"),
        field: "DocNo",
        fieldDisplay: "false",
        slot: "DocNo",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.SupplierName"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.Address"),
        field: "Address",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.GSTNO"),
        field: "GSTNO",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.PaymentTermsDesc"),
        field: "PaymentTermsDesc",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.DeliTermsDesc"),
        field: "DeliTermsDesc",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.GrnPo"),
        field: "RefNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.InvoiceNo"),
        field: "InvoiceNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.InvoiceDate"),
        field: "InvoiceDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.grn.ItemCount"),
        field: "ItemCount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.ItemQty"),
        field: "ItemQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.Value"),
        field: "NetAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.ApprovalStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "ApprovalStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.PaymentStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "PaymentStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: ColumnVisible.value,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const IsCreatePopup = () => {
      let permissionResult: any = checkPermission(Rights, "Add");

      if (permissionResult.hasPermission) {
        visible.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };
    const IsCreate = (val, EntityId, OperationId) => {
      router.push({
        name: "grn",
        query: {
          param: val,
          StoreId: ParamValues.value.Id,
          status: ParamValues.value.Type,
          Type: ParamValues.value.status,
          OperationId: OperationId,
          EntityId: EntityId,
          storebranchmapid: StoreBrMapId,
          BranchId: Number(routes.query.BranchId ?? 0),
          IsZeroBill: IsZeroBill,
          IsDraft: 1,
        },
      });
    };

    function IsConfirmEdit(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = false;
        popup.value.Deletemodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsEdit(data) {
      debugger;
      let pValue = "",
        EId = 0,
        COId = 0,
        UOId = 0,
        currentStep = 1;

      if (data.DocType == 7) {
        pValue = "GRN With PO";
        EId = 127;
        COId = 432;
        UOId = 454;
      } else if (data.DocType == 8) {
        pValue = "GRN Without PO";
        EId = 128;
        COId = 436;
        UOId = 458;
      } else {
        pValue = "DC";
        EId = 322;
        COId = 995;
        UOId = 997;
      }

      router.push({
        path: "/grn",
        query: {
          param: pValue,
          doctype: data.DocType,
          Id: data.StockTransId,
          StoreId: ParamValues.value.Id,
          status: ParamValues.value.Type,
          Type: ParamValues.value.status,
          EntityId: EId,
          OperationId: data.IsDraft == 1 ? COId : UOId,
          currentStep: currentStep,
          storebranchmapid: StoreBrMapId,
          IsZeroBill: IsZeroBill,
          IsDraft: data.IsDraft,
          BranchId: Number(routes.query.BranchId ?? 0),
        },
      });
    }

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    // Debounced search for server-side filtering
    function SearchBox(value) {
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = input;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }, 300);
    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;
        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = Type == "StoreId" ? "StoreId" : "SupplierId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
        const columnValue1 = filterItems.value.SupplierId
          ? filterItems.value.SupplierId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        let response = await commonService.List(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          "7,8,19",
          pageNum,
          pageSize,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          "",
          "",
          "",
          "",
          "",
          "",
          Condition
        );
        debugger;
        items.value = response["result"].map((item) => {
          item.NetAmount = Number(item.NetAmount).toFixed(2);
          return item;
        });

        // rowsCount.value =
        //   response["result"].length > 0
        //     ? response["result"][0]["rowscount"]
        //     : 0;

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log("GRN table datas", items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = 0;

        const columnName = Type == "StoreId" ? "StoreId" : "SupplierId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
        const columnValue1 = filterItems.value.SupplierId
          ? filterItems.value.SupplierId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        let response = await commonService.List(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          "7,8,19",

          0,
          0,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          "",
          "",
          "",
          "",
          "",
          "",
          Condition
        );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        response["result"] = response["result"].map((item) => {
          item.NetAmount = Number(item.NetAmount).toFixed(2);

          // Add status information to DocNo
          let docStatus = "";
          if (item.IsDraft == "1") {
            docStatus = "Draft";
          }

          let docTypeInfo = "";
          if (item.DocType == 7) {
            docTypeInfo = "( GRN With PO )";
          } else if (item.DocType == 8) {
            docTypeInfo = "( GRN Without PO )";
          } else if (item.DocType == 19) {
            if (item.DCType == 1) {
              docTypeInfo = `( DC Consignee ) ${item.DCStatus == 0
                ? "GRN pending"
                : item.DCStatus == 1
                  ? "GRN partial"
                  : item.DCStatus == 2
                    ? "GRN completed"
                    : ""
                }`;
            } else if (item.DCType == 2) {
              docTypeInfo = "( DC Others )";
            } else if (item.DCType == 3) {
              docTypeInfo = `( DC With PO ) ${item.DCStatus == 0
                ? "GRN pending"
                : item.DCStatus == 1
                  ? "GRN partial"
                  : item.DCStatus == 2
                    ? "GRN completed"
                    : ""
                }`;
            } else if (item.DCType == 4) {
              docTypeInfo = `( DC Without PO ) ${item.DCStatus == 0
                ? "GRN pending"
                : item.DCStatus == 1
                  ? "GRN partial"
                  : item.DCStatus == 2
                    ? "GRN completed"
                    : ""
                }`;
            }
          }

          // Combine DocNo with status information
          item.DocNo = `${item.DocNo}${docStatus ? " (" + docStatus + ")" : ""
            }\n${docTypeInfo}`;

          if (item.IsApproved == "0") {
            item.ApprovalStatus = "Pending";
          } else if (item.IsApproved == "1") {
            item.ApprovalStatus = "Approved";
          } else if (item.IsApproved == "3") {
            item.ApprovalStatus = "Declined";
          } else {
            item.ApprovalStatus = "-";
          }

          if (item.DocType == 19) {
            item.PaymentStatus = "-";
          } else {
            if (item.IsDraft != 1 && item.PaymentFlag == "2") {
              item.PaymentStatus = "Pending";
            } else if (item.IsDraft != 1 && item.PaymentFlag == "3") {
              item.PaymentStatus = "Partially Paid";
            } else if (item.IsDraft != 1 && item.PaymentFlag == "1") {
              item.PaymentStatus = "Paid";
            } else if (item.IsDraft != 1 && item.PaymentFlag == "4") {
              item.PaymentStatus = "OverDue";
            } else {
              item.PaymentStatus = "-";
            }
          }

          return item;
        });

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          // Add headers and fields
          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          filteredItem["Approval Status"] = item.ApprovalStatus;
          filteredItem["Payment Status"] = item.PaymentStatus;
          return filteredItem;
        });

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    let ObjVal5 = reactive({
      arraylenght: 0,
    });

    function update() {
      debugger;
      emit("update:modelValue", ObjVal5);
    }

    async function GRNDetails() {
      debugger;
      try {
        debugger;

        let response = await commonService.GetListByPIId(
          DetailsId.value.PIId || DetailsId.value.PRId
        );
        debugger;
        items.value = response["result"];
        ObjVal5.arraylenght = response["result"].length;
        update();

        if (response["result"].length > 0) {
          rowsCount.value = response["result"][0]["rowscount"];
        }

        console.log(items.value);
      } catch (error) {
        console.log(error);
      }
    }

    //Delete Values in Table
    const IsDelete = async (data) => {
      try {
        const response = await commonService.DeleteStockInTM(data.StockTransId);
        let message = response["ErrorInfo"].ErrorCode;
        if (message == null) {
          popup.value.Deletemodel = false;
          popup.value.deletepop = true;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    // Popup-Close
    function closetrigger() {
      popup.value.deletepop = false;
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = ObjData.StockTransId;
      ParameterValues.value.BranchId = ObjData.BranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
      PrintType.value.FormId = 2;
    }

    function BarcodePrint(ObjData) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = ObjData.StockTransId;
      ParameterValues.value.BranchId = ObjData.BranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
      PrintType.value.FormId = 106;
    }
    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    const filtervisible = ref(false);
    let FilterLoading = ref(true);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      SupplierName: "",
      SupplierId: "",
      Code: "",
    });

    let emitedfilterItems = ref({
      SupplierName: "",
      SupplierId: "",
      Code: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);

    const EmitSupplierName = (data) => {
      emitedfilterItems.value.SupplierName = data;
    };

    const EmitSupplierId = (data) => {
      emitedfilterItems.value.SupplierId = data;
    };

    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      filterItems.value.SupplierName = emitedfilterItems.value.SupplierName;
      filterItems.value.SupplierId = emitedfilterItems.value.SupplierId;
      filterItems.value.Code = emitedfilterItems.value.Code;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.SupplierId = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      } else if (data == "SupplierName") {
        filterItems.value.SupplierId = "";
        removechipvalue.value = 2;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };
    ///
    const rowFocus = ref(false);

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
      router.push({
        path: "/GrnTableDetails",
        query: {
          Id: event.data ? event.data.StockTransId : event.StockTransId,
          BranchId: event.data ? event.data.BranchId : event.BranchId,
          EntityId: event.data ? event.data.EntityId : event.EntityId,
          DocType: event.data ? event.data.DocType : event.DocType,
        },
      });
    }
    return {
      functionrights,
      datapass,
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      menu,
      toggle,
      itemList,
      popup,
      dataEdit,
      IsConfirmEdit,
      IsConfirmDel,
      closetrigger,
      visible,
      IsCreatePopup,
      state,
      rowsCount,
      totalPages,
      pageSizes,
      grnrRoute,
      ObjVal5,
      loading,
      paramValues1,
      QueryStringValue4,
      ObjVal4,
      CrystalReportPopup,
      ParamValues,
      ParameterValues,
      PrintType,
      hidepopup,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      EmitSupplierName,
      EmitSupplierId,
      Emitcode,
      filterItems,
      removeChip,
      removechipvalue,
      SearchBox,
      ShowRows,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      windowWidth,
      togglevisible,
      RowClick,
      DetailsId,
      barcodeValues,
    };
  },
});
</script>
<style>
.grn-icon {
  width: 100px;
  height: 100px;
}

.grnpopup {
  padding: 15px;
  border: 1px solid #e1e1e1;
}

.grnbtn {
  background-color: #0148e2 !important;
  color: #ffffff !important;
  border-radius: 5px;
  padding: 8px 36% !important;
}
</style>
